import { ProcessingStatus } from '@/hooks/useKeyValOperations';

export const APP_ROUTES = {
  ONBOARDING: '/ui/onboarding',
  HOME: '/ui',
  MY_WORKFORCE: '/ui/my-workforce',
  SIGN_IN: '/ui/sign-in',
}

export const MULTI_EXECUTION_AGENTS = ['blog-post-content-strategizer', 'blog-post-content-refresher'];
export const REVIEW_BASED_AGENTS = ['mardi'];
export const HEADLESS_AGENTS = ['blog-post-draft-writing', 'aeo-job-creator', 'global-chat-agent'];

// List of routes that are publicly accessible without authentication
export const publicRoutes = [
  APP_ROUTES.SIGN_IN
];

// List of common personal email domains
export const PERSONAL_EMAIL_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'icloud.com',
  'aol.com',
  'protonmail.com',
  'mail.com',
  'zoho.com',
  'yandex.com',
  'live.com',
  'inbox.com',
  'gmx.com',
  'fastmail.com',
  'me.com'
];

// Screens where config CTA is enabled
export const CONFIG_CTA_ENABLED_SCREENS = ['idle', 'completed'];

export const showCreateOrg = false; // Flag to control create org option visibility

// Export navigation constants
export * from './navigation';

// Sidebar supported agents - these agents have to pass the props to output screen
export const SIDEBAR_SUPPORTED_AGENTS = [
  "google-ads-campaign-analyser",
  "linkedin-ads-campaign-analyser",
  "sales-battle-card-generator",
];

export const VARIABLE_CATEGORY_MAPPING = {
  "primary_variables": "1"
}

export const BRAND_NAME_SHORT_NAME = "brand_name";
export const BRAND_DESCRIPTION_SHORT_NAME = "brand_description";
export const COMPETITORS_SHORT_NAME = "competitors";
export const OWN_PRODUCTS_SHORT_NAME = "own_products";
export const BRAND_WRITING_GUIDELINES_SHORT_NAME = "brand_writing_guidelines";
export const BRAND_WRITING_RULES_SHORT_NAME = "brand_writing_rules";
export const BRAND_DOMAIN_SHORT_NAME = "brand_domain";
export const BLOG_URL_SHORT_NAME = "blog_url";
export const PRIMARY_SEARCH_LOCATION_SHORT_NAME = "primary_search_location";
export const BRAND_AUDIENCES_SHORT_NAME = "brand_audiences";

export const POLLING_INTERVAL = 15000; // Poll every 15 seconds

export const statusConfig = {
  [ProcessingStatus.PENDING]: {
    label: "Todo",
    color: "text-gray-600"
  },
  [ProcessingStatus.IN_PROGRESS]: {
    label: "In Progress",
    color: "text-gray-600"
  },
  [ProcessingStatus.COMPLETED]: {
    label: "Done",
    color: "text-emerald-500"
  },
  [ProcessingStatus.WAITING_FOR_APPROVAL]: {
    label: "Review",
    color: "text-blue-600"
  },
  [ProcessingStatus.FAILED]: {
    label: "Failed",
    color: "text-red-500"
  }
};

// List of StriveLabs internal users — gates Marketplace, Experiments, and other internal-only features
export const STRIVELABS_USERS: string[] = [
  'mari@strivelabs.ai',
  'raghuram@strivelabs.ai',
  'arunkumar@strivelabs.ai',
  'jahirbasha.nabadulla@strivelabs.ai',
  'sakthivel@strivelabs.ai',
  'satwik@strivelabs.ai',
  'gb@strivelabs.ai'
];
